var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.all_store_categories.length > 0)?_c('div',{staticClass:"filter-menu-section inner-filter-menu",class:{ fixed_top: _vm.fixTop },attrs:{"id":"filter-menu"}},[(_vm.all_store_menu_items_being_loaded)?_c('h1',[_vm._v(_vm._s(_vm._T('LOADING'))+"....")]):_c('div',{staticClass:"filter-menu"},[_c('categories'),_c('search-bar')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }